module.exports = __webpack_public_path__ + "Flag-862.c550c8a3c8867c35151d362f0fe911f8.svg";